module.exports = __webpack_public_path__ + "static/media/roboto-500italic.288ad9c6.woff";